import { render, staticRenderFns } from "./marginReminderDialog.vue?vue&type=template&id=9f550df0&scoped=true&"
import script from "./marginReminderDialog.vue?vue&type=script&lang=js&"
export * from "./marginReminderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f550df0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f550df0')) {
      api.createRecord('9f550df0', component.options)
    } else {
      api.reload('9f550df0', component.options)
    }
    module.hot.accept("./marginReminderDialog.vue?vue&type=template&id=9f550df0&scoped=true&", function () {
      api.rerender('9f550df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/mawb/marginReminderDialog.vue"
export default component.exports